// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentContainer_wrapper__3PduR","content":"ContentContainer_content__VByKn"};